import { Action, createReducer, on } from '@ngrx/store';

import { GlobalUserAction } from '../actions';
import { GlobalUserState } from '../states/user.state';

const initialState: GlobalUserState = {
  first_name: '',
  last_name: '',
  email: '',
  roles: [],
};

const authReducer = createReducer(
  initialState,
  on(
    GlobalUserAction.SetMe,
    (state, { email, first_name, last_name, roles }) => ({
      ...state,
      email,
      first_name,
      last_name,
      roles,
    })
  ),
  on(GlobalUserAction.ResetAll, () => initialState)
);

export function GlobalUserReducer(
  state: GlobalUserState | undefined,
  action: Action
) {
  return authReducer(state, action);
}
